/**
 * admin-ops KPI API クライアント（Phase 3 / issue #197。sales_counter 単体前提へ縮退 #1479）。
 *
 * spec/ai-inbox-core/admin-ops/design.md §5 参照。
 */

export interface KpiOverviewPoint {
  month: string;
  paidWorkspaceCount: number;
  mrr: number;
  monthlyChurnRate: number | null;
}

export interface KpiTargetPoint {
  month: string;
  kpiName: 'paid_workspace_count' | 'mrr' | 'monthly_churn_rate';
  targetValue: number | null;
}

export interface KpiOverviewResponse {
  series: ReadonlyArray<KpiOverviewPoint>;
  targets: ReadonlyArray<KpiTargetPoint>;
  current: KpiOverviewPoint;
  snapshottedAt: string | null;
  productLabel: string;
}

function normalizeBaseUrl(baseUrl: string): string {
  return baseUrl.replace(/\/$/, '');
}

export async function fetchKpiOverview(baseUrl: string): Promise<KpiOverviewResponse> {
  const url = `${normalizeBaseUrl(baseUrl)}/api/v1/kpi/overview`;
  const res = await fetch(url, {
    credentials: 'include',
    headers: { Accept: 'application/json' },
  });
  if (!res.ok) {
    throw new Error(`admin-ops API /kpi/overview failed: ${res.status}`);
  }
  return (await res.json()) as KpiOverviewResponse;
}

export async function triggerKpiSnapshot(
  baseUrl: string,
  month?: string,
): Promise<{ status: 'ok'; month: string; rowsWritten: number }> {
  const url = `${normalizeBaseUrl(baseUrl)}/api/v1/cron/kpi-snapshot`;
  const res = await fetch(url, {
    method: 'POST',
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(month ? { month } : {}),
  });
  if (!res.ok) {
    throw new Error(`admin-ops API /cron/kpi-snapshot failed: ${res.status}`);
  }
  return (await res.json()) as { status: 'ok'; month: string; rowsWritten: number };
}
